export default __webpack_public_path__ + "static/media/auto-contact-icon.c3c03af8.svg";